export default [
    {
        id: 0,
        title: 'benim',
        gender: 'x',
        mineSuffix: 'kendisinin',
        mine: 'kendisi',
        suffix: "kendim",
        lastSuffix: 'kendisi'
    },
    {
        id: 1,
        title: 'amca',
        gender: 'e',
        mineSuffix: 'amcamın',
        mine: 'amcam',
        suffix: 'amcasının',
        lastSuffix: 'amcası',
    },
    {
        id: 2,
        title: 'anne',
        gender: 'k',
        mineSuffix: 'annemin',
        mine: 'annem',
        suffix: 'annesinin',
        lastSuffix: 'annesi',
    },
    {
        id: 3,
        title: 'anneanne',
        gender: 'k',
        mineSuffix: 'anneannemin',
        mine: 'anneannem',
        suffix: 'anneannesinin',
        lastSuffix: 'anneannesi',
    },
    {
        id: 4,
        title: 'baba',
        gender: 'e',
        mineSuffix: 'babamın',
        mine: 'babam',
        suffix: 'babasının',
        lastSuffix: 'babası',
    },
    {
        id: 5,
        title: 'babanne',
        gender: 'k',
        mineSuffix: 'babannemin',
        mine: 'babannem',
        suffix: 'babannesinin',
        lastSuffix: 'babannesi',
    },
    {
        id: 6,
        title: 'bacanak',
        gender: 'e',
        mineSuffix: 'bacanağımın',
        mine: 'bacanağım',
        suffix: 'bacanağının',
        lastSuffix: 'bacanağı',
        only: 'e',
    },
    {
        id: 7,
        title: 'baldız',
        gender: 'k',
        mineSuffix: 'baldızımın',
        mine: 'baldızım',
        suffix: 'baldızının',
        lastSuffix: 'baldızı',
        only: 'e',
    },
    {
        id: 8,
        title: 'damat',
        gender: 'e',
        mineSuffix: 'damadımın',
        mine: 'damadım',
        suffix: 'damadının',
        lastSuffix: 'damadı',
    },
    {
        id: 9,
        title: 'dayı',
        gender: 'e',
        mineSuffix: 'dayımın',
        mine: 'dayım',
        suffix: 'dayısının',
        lastSuffix: 'dayısı',
    },
    {
        id: 10,
        title: 'dede',
        gender: 'e',
        mineSuffix: 'dedemin',
        mine: 'dedem',
        suffix: 'dedesinin',
        lastSuffix: 'dedesi',
    },
    {
        id: 11,
        title: 'elti',
        gender: 'k',
        mineSuffix: 'eltimin',
        mine: 'eltim',
        suffix: 'eltisinin',
        lastSuffix: 'eltisi',
        only: 'k',
    },
    {
        id: 12,
        title: 'enişte',
        gender: 'e',
        mineSuffix: 'eniştemin',
        mine: 'eniştem',
        suffix: 'eniştesinin',
        lastSuffix: 'eniştesi',
    },
    {
        id: 13,
        title: 'erkek kardeş',
        gender: 'e',
        mineSuffix: 'erkek kardeşimin',
        mine: 'erkek kardeşim',
        suffix: 'erkek kardeşinin',
        lastSuffix: 'erkek kardeşi',
    },
    {
        id: 14,
        title: 'gelin',
        gender: 'k',
        mineSuffix: 'gelinimin',
        mine: 'gelinim',
        suffix: 'gelininin',
        lastSuffix: 'gelini',
    },
    {
        id: 15,
        title: 'hala',
        gender: 'k',
        mineSuffix: 'halamın',
        mine: 'halam',
        suffix: 'halasının',
        lastSuffix: 'halası',
    },
    {
        id: 16,
        title: 'karı',
        gender: 'k',
        mineSuffix: 'karımın',
        mine: 'karım',
        suffix: 'karısının',
        lastSuffix: 'karısı',
        only: 'e',
    },
    {
        id: 17,
        title: 'kaynana',
        gender: 'k',
        mineSuffix: 'kaynanamın',
        mine: 'kaynanam',
        suffix: 'kaynanasının',
        lastSuffix: 'kaynanası',
    },
    {
        id: 18,
        title: 'kayınpeder',
        gender: 'e',
        mineSuffix: 'kayınpederimin',
        mine: 'kayınpederim',
        suffix: 'kayınpederinin',
        lastSuffix: 'kayınpederi',
    },
    {
        id: 19,
        title: 'kayınço',
        gender: 'e',
        mineSuffix: 'kayınçomun',
        mine: 'kayınçom',
        suffix: 'kayınçosunun',
        lastSuffix: 'kayınçosu',
        only: 'e',
    },
    {
        id: 20,
        title: 'koca',
        gender: 'e',
        mineSuffix: 'kocamın',
        mine: 'kocam',
        suffix: 'kocasının',
        lastSuffix: 'kocası',
        only: 'k',
    },
    {
        id: 21,
        title: 'kuzen',
        gender: 'x',
        mineSuffix: 'kuzenimin',
        mine: 'kuzenim',
        suffix: 'kuzeninin',
        lastSuffix: 'kuzeni',
    },
    {
        id: 22,
        title: 'kız kardeş',
        gender: 'k',
        mineSuffix: 'kız kardeşimin',
        mine: 'kız kardeşim',
        suffix: 'kız kardeşinin',
        lastSuffix: 'kız kardeşi',
    },
    {
        id: 23,
        title: 'teyze',
        gender: 'k',
        mineSuffix: 'teyzemin',
        mine: 'teyzem',
        suffix: 'teyzesinin',
        lastSuffix: 'teyzesi',
    },
    {
        id: 24,
        title: 'torun',
        gender: 'x',
        mineSuffix: 'torunumun',
        mine: 'torunum',
        suffix: 'torununun',
        lastSuffix: 'torunu',
    },
    {
        id: 25,
        title: 'yenge',
        gender: 'k',
        mineSuffix: 'yengemin',
        mine: 'yengem',
        suffix: 'yengesinin',
        lastSuffix: 'yengesi',
    },
    {
        id: 26,
        title: 'oğul',
        gender: 'x',
        mineSuffix: 'oğlumun',
        mine: 'oğlum',
        suffix: 'oğlunun',
        lastSuffix: 'oğlu',
    },
    {
        id: 27,
        title: 'görümce',
        gender: 'k',
        mineSuffix: 'görümcemin',
        mine: 'görümcem',
        suffix: 'görümcesinin',
        lastSuffix: 'görümcesi',
        only: 'k',
    },
    {
        id: 28,
        title: 'yeğen',
        gender: 'x',
        mineSuffix: 'yeğenimin',
        mine: 'yeğenim',
        suffix: 'yeğeninin',
        lastSuffix: 'yeğeni'
    },
    {
        id: 29,
        title: 'kız',
        gender: 'x',
        mineSuffix: 'kızımın',
        mine: 'kızım',
        suffix: 'kızının',
        lastSuffix: 'kızı',
    },
    {
        id: 30,
        title: 'çocuk',
        gender: 'x',
        mineSuffix: 'çocuğumun',
        mine: 'çocuğum',
        suffix: 'çocuğunun',
        lastSuffix: 'çocuğu',
    },
]
